module.exports = __webpack_public_path__ + "img/xroad7_large.8056c2c5.png";